/**
 * The site compliance report (FR-FIA-23, FR-FIA-24): what an inspector or an auditor asks for at a
 * given date, and the exemptions recorded over a period.
 */
import { z } from 'zod';
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD');
export const complianceQuerySchema = z
    .object({
    /** The date the report describes; today by default. */
    date: isoDate.optional(),
    /** The period of the exemptions; the start of the year of the date to the date by default. */
    from: isoDate.optional(),
    to: isoDate.optional(),
})
    .refine((q) => !q.from || !q.to || q.from <= q.to, {
    message: 'The period ends before it starts',
    path: ['to'],
});
export const complianceExportQuerySchema = complianceQuerySchema.and(z.object({ format: z.enum(['pdf', 'xlsx']).default('pdf') }));
/** Families of the dated documents the report watches. */
export const COMPLIANCE_DOCUMENT_FAMILIES = [
    'CAP',
    'AUTHORIZATION',
    'OTHER_DOCUMENT',
    'CONTRACT',
];
//# sourceMappingURL=compliance.js.map